/**
 * ReportConfigsPage — standalone page for named report configurations.
 *
 * Phase 4.3.GAPCONF: Report Configurations get their own sidebar section
 * (coexisting temporarily with ALM Parameters while the transition is ongoing).
 *
 * The card itself (ReportConfigsCard) handles all state and mutations.
 */
import { ReportConfigsCard } from './ReportConfigsCard';

export function ReportConfigsPage() {
  return (
    <div className="flex flex-col gap-4 p-6 max-w-5xl mx-auto">
      <div>
        <h1 className="text-lg font-semibold text-slate-800">Configurations de rapports</h1>
        <p className="text-xs text-slate-500 mt-0.5">
          Paramètres nommés et réutilisables pour les 10 types de rapports ALM.
          Chaque configuration peut être planifiée ou déclenchée manuellement.
        </p>
      </div>
      <ReportConfigsCard />
    </div>
  );
}
